import { render, staticRenderFns } from "./transacions_empty.vue?vue&type=template&id=47642bed&"
import script from "./transacions_empty.vue?vue&type=script&lang=js&"
export * from "./transacions_empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports